<h1 id="title" class="title">Change Password</h1>
<p class="sub-title">Request a verification code to update your password.</p>

<form #requestChangeForm="ngForm" aria-labelledby="title">
  <div class="form-control-group">
    <label class="label" for="input-email">Email address:</label>
    <input nbInput
           fullWidth
           [(ngModel)]="email"
           name="email"
           id="input-email"
           placeholder="Email address"
           fieldSize="large"
           [disabled]="true">
  </div>

  <button nbButton
          fullWidth
          status="primary"
          size="large"
          type="button"
          [disabled]="submitted || !email"
          [class.btn-pulse]="submitted"
          (click)="requestChangePassword()">
    Request change password
  </button>
</form>
